<script setup>
import DefaultLayout from '@/layouts/default.vue'
</script>
<template>
  <DefaultLayout :isArticle="true">
     <slot />
  </DefaultLayout>
</template>